import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/i18n/LanguageProvider";

type LanguageSwitcherProps = {
  className?: string;
  onNavigate?: () => void;
};

const LanguageSwitcher = ({ className, onNavigate }: LanguageSwitcherProps) => {
  const { lang, t, altPath } = useLanguage();

  const options = [
    { code: "en" as const, label: "EN", full: t("English") },
    { code: "he" as const, label: "עב", full: t("Hebrew") },
  ];

  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-md border border-border/60 bg-muted/20 px-1.5 py-1",
        className,
      )}
      role="group"
      aria-label={t("Switch language")}
    >
      <Globe aria-hidden="true" className="h-3.5 w-3.5 text-muted-foreground" />
      {options.map((option) => {
        const isCurrent = option.code === lang;

        return (
          <a
            key={option.code}
            href={altPath(option.code)}
            onClick={onNavigate}
            lang={option.code}
            hrefLang={option.code}
            aria-current={isCurrent ? "true" : undefined}
            aria-label={option.full}
            className={cn(
              "min-w-[2rem] rounded px-2 py-1 text-center text-xs font-semibold transition-colors",
              isCurrent
                ? "bg-primary/15 text-primary"
                : "text-muted-foreground hover:text-primary",
            )}
          >
            {option.label}
          </a>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
